import { useChecklistContext } from '../../../../contexts';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';

export const ReportOnTitleRefName = 'report-on-title';

export default function ReportOnTitleSection() {
  const { checklist } = useChecklistContext();

  const {
    reportOnTitle,
  } = checklist ?? {};

  return (
    <PaddedGenericSection
      refName={ReportOnTitleRefName}
      section={ChecklistSection.REPORT_ON_TITLE}
      checklistItem={reportOnTitle}
    >
      <p>level 0</p>
    </PaddedGenericSection>
  );
}
